import { render, staticRenderFns } from "./MarkdownElement.vue?vue&type=template&id=084d2902&scoped=true&"
import script from "./MarkdownElement.vue?vue&type=script&lang=ts&"
export * from "./MarkdownElement.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownElement.vue?vue&type=style&index=0&id=084d2902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d2902",
  null
  
)

export default component.exports